<div class="banner-container">
  <div class="banner">
    <p class="banner-text banner-text-primary">
      <ng-content select="title"></ng-content>
    </p>
    <p class="banner-text banner-text-secondary">
      <ng-content select="subtitle"></ng-content>
    </p>
  </div>
</div>
